import * as React from 'react'
import { MessageEditor } from '@/shared/ui'
import { EmojiPicker } from '@/modules/comunidade/components/EmojiPicker'
import {
  buildLinkPreview,
  extractFirstUrlFromHtml,
} from '@/modules/comunidade/services/linkPreviewService'
import { CommunityLinkPreviewCard } from '@/modules/comunidade/components/CommunityLinkPreviewCard'
import { COMMUNITY_ATTACHMENT_ACCEPT } from '@/modules/comunidade/utils/communityAttachments'

export type AnalysisPostComposerProps = {
  value: string
  onChange: (html: string) => void
  disabled?: boolean
  placeholder?: string
  onAddFiles: (files: File[]) => void
  onSubmit?: () => void
  submitDisabled?: boolean
}

export function AnalysisPostComposer({
  value,
  onChange,
  disabled,
  placeholder,
  onAddFiles,
  onSubmit,
  submitDisabled,
}: AnalysisPostComposerProps) {
  const linkPreview = React.useMemo(() => {
    const url = extractFirstUrlFromHtml(value || '')
    if (!url) return null
    return buildLinkPreview(url)
  }, [value])

  return (
    <div className="space-y-2">
      {linkPreview && (
        <div className="mb-2">
          <CommunityLinkPreviewCard preview={linkPreview} />
        </div>
      )}

      <MessageEditor
        variant="slack"
        enableMentions
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        sendOnEnter={false}
        showSubmitButton={!!onSubmit}
        onSubmit={onSubmit}
        submitDisabled={submitDisabled}
        onPasteFiles={onAddFiles}
        onPickFiles={onAddFiles}
        pickFilesAccept={COMMUNITY_ATTACHMENT_ACCEPT}
        pickFilesMultiple
        stripImages
        renderEmojiPicker={({ onSelect, onClose, className }) => (
          <EmojiPicker className={className} onSelect={onSelect} onClose={onClose} />
        )}
      />
    </div>
  )
}

